import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { TextViewComponent } from './text-view.component';
import { InputContainerComponent } from '../input-container/input-container.component';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, InputContainerComponent],
    selector: 'wd-text-input',
    templateUrl: 'text-input.component.html',
    styleUrls: ['../styles/input.component.css', '../styles/view.component.css'],
})
export class TextInputComponent extends TextViewComponent {
	@ViewChild('inputValue') inputValue!: NgModel;
	@Input() superscript = false;

	constructor() {
		super();
	}

	override onChange(changes?: SimpleChanges): void {
		if (this.superscript && this.model) {
			const str = String(this.model);
			const converted = str.replace(/\+/g, '⁺').replace(/x/gi, 'ˣ');
			if (converted !== str) {
				this.model = converted;
			}
		}
		super.onChange(changes);
	}

	override helpText(): string {
		if (this.inputValue === undefined || this.inputValue.touched) return super.helpText();
		return '';
	}
}
